import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UnitsService } from 'src/app/services/units.service';

@Component({
  selector: 'app-verify-payment',
  templateUrl: './verify-payment.component.html',
  styleUrls: ['./verify-payment.component.scss']
})
export class VerifyPaymentComponent implements OnInit {

  constructor(private snackBar: SnackbarService,
    private actRoute: ActivatedRoute, private unitService: UnitsService,) { }


    message: string;
  async ngOnInit() {
    this.actRoute.queryParamMap.subscribe(async (params: any) => {
      this.message = params.get('msg') as string;
      //console.log(paymentId);
      // let data = {"paymentId":paymentId}
      // await this.unitService.verifyPayment(paymentId).then(() => {
      //   this.snackBar.success("Payment Successfully!!!");
      // });
    });
  }

}
